import z from 'zod';

export const TaskHistoryEventPostSchema = z.object({
  task_token: z.string(),
  user_id: z.string().uuid(),
  task_state: z.string(),
});

export const TaskHistoryEventSchema = TaskHistoryEventPostSchema.extend({
  user_id: z.string().uuid(),
  updated_at: z.coerce.date(),
});

export type TaskHistoryEventPost = z.infer<typeof TaskHistoryEventPostSchema>;
export type TaskHistoryEvent = z.infer<typeof TaskHistoryEventSchema>;
